export default "__VITE_ASSET__1wBfiBsh__"